<template>
    <div v-if="account">
 

    <BCard>
      <BRow>
        <BCol cols="12" md="6" >
          <table class="mt-xl-0 w-100">
            <ViewData vsIcon="FolderIcon" vsLabel="NIF" :vsValue="account.billing_nif"  />
            <ViewData vsIcon="DollarSignIcon" vsLabel="Cuenta bancaria" :vsValue="account.iban" />
            <ViewData vsIcon="DollarSignIcon" vsLabel="SWIFT/BIC" :vsValue="account.swift_bic ? account.swift_bic : '-' " />

            <ViewData vsIcon="FileTextIcon" vsLabel="Razón social" :vsValue="account.billing_full_name" />
            <ViewData vsIcon="SendIcon" vsLabel="Emitir facturaE" :vsValue="account.emit_face" vsCheckbox />

          </table>
        </BCol>
        <BCol cols="12" md="6" >
          <table class="mt-xl-0 w-100">
            <ViewData vsIcon="FolderIcon" vsLabel="Forma jurídica" :vsValue="account.customer_type.name"  />
            <ViewData vsIcon="DollarSignIcon" vsLabel="Método de pago" :vsValue="account.payment_method.name" />
            <ViewData vsIcon="HelpCircleIcon" vsLabel="Entidad legal" :vsValue="account.is_legal_entity" vsCheckbox />
          </table>
        </BCol>
      </BRow>
    </BCard>

    </div>
</template>

<script>
import axios from '@axios';
import { computed, ref, inject } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';
import { BCard, BCol, BRow, BButton } from 'bootstrap-vue';
import router from '@/router';
import popups from '@/hooks/popups';

export default {
    components: { BRow, BCard, BCol, ViewData, BButton },
    setup() {
        const account = inject('account')


        return {account}
    },
}
</script>

<style>

</style>